import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDevice } from '../../providers/Device';
import { Column } from './Column';
import { Row } from './Row';
export const ResponsiveRow = (props)=>{
    const { isMobileDevice } = useDevice();
    const Layout = isMobileDevice ? Column : Row;
    return /*#__PURE__*/ _jsx(Layout, _object_spread({}, props));
};
ResponsiveRow.displayName = 'ResponsiveRow';
